// 前后台共用变量
export default {
  web_name: '国科前端考试系统',
  web_domain: 'http://103.27.4.146:3001', // 访问域名
  file_domain: 'https://file.goktech.cn/',
  name_reg: /^[a-z\u4e00-\u9fa5]{3,20}$/i, // 帐号验证
  name_txt: '3至10个英文或中文字符', // 帐号规则
  mobile_reg: /(?:^1[3456789]|^9[28])\d{9}$/,
  mobile_txt: '请输入正确的手机号格式',
  upFile_maxSize: 1024 * 1024 * 50, // 上传文件大小限制
  upFile_accept: /^image\//, // 上传文件格式限制
  user_type: {
    0: '超级管理员',
    1: '普通用户'
  },
  questionTypes: [{
      value: 1,
      label: "判断题"
    },
    {
      value: 2,
      label: "单选题"
    },
    {
      value: 3,
      label: "多选题"
    },
    {
      value: 4,
      label: "填空题"
    },
    {
      value: 5,
      label: "简答题"
    },
    {
      value: 6,
      label: "综合题"
    }
  ],
  examTypes: [{
    value: 1,
    label: "前端"
  }],
  // 页面权限设置 0:超管，1：普通用户
  page_grade: {
    changePassword: 1, // 修改密码（必须登录）
    examRecord: 1, // 答题记录
    examHistory: 1, // 历史记录
    examAdd: 0, // 生成试卷
    examEdit: 0, //编辑试卷
    examDetail: 1, // 试题详情
    examJudge: 0, //批改试卷
    judge: 0, //批改试卷
    startExercise: 1, //开始答题
    recordDetail: 1, //答题记录详情
    saveExamRecord:0, //提交阅卷结果
    userAdd: 0, //用户新增,
    userUpdate: 0, //更新,
    updatePassword: 1,
    upFile: 1
  },
  mixin: {
    methods: {
      dealUserInfo: function (o) {
        if (this.hasOwnProperty('userInfo')) {
          this.userInfo = o
        }
        const g = this.grade
        if (g) {
          const p = this.page_grade
          for (var k in g) {
            if (g.hasOwnProperty(k)) {

              g[k] = o.userType > p[k]
            }
          }
        }
      }
    },
    created: function () {
      this.dealUserInfo(this.$store.state.data)
    },
    watch: {
      '$store.state.data': 'dealUserInfo'
    }
  }
}
